export function Preloader(element) {
    function show() {
        element.parentNode.classList.add('btn_loading');
    }

    function hide() {
        element.parentElement.classList.remove('btn_loading');
    }

    return {
        show,
        hide,
    };
}
